module.exports = __webpack_public_path__ + "static/fonts/TITLE.ttf";